export function getResponsiveProps(componentName, componentProp, tokenSubgroup, responsiveProp) {
    if (!responsiveProp)
        return {};
    if (typeof responsiveProp === 'string') {
        return {
            [`--bv-${componentName}-${componentProp}-xs`]: `var(--bv-${tokenSubgroup}-${responsiveProp})`
        };
    }
    return Object.fromEntries(Object.entries(responsiveProp).map(([breakpointAlias, aliasOrScale]) => [
        `--bv-${componentName}-${componentProp}-${breakpointAlias}`,
        `var(--bv-${tokenSubgroup}-${aliasOrScale})`
    ]));
}
export function getResponsiveValue(componentName, componentProp, responsiveProp) {
    if (!responsiveProp)
        return {};
    if (typeof responsiveProp === 'string') {
        return {
            [`--bv-${componentName}-${componentProp}-xs`]: responsiveProp
        };
    }
    return Object.fromEntries(Object.entries(responsiveProp).map(([breakpointAlias, responsiveValue]) => [
        `--bv-${componentName}-${componentProp}-${breakpointAlias}`,
        responsiveValue
    ]));
}
//# sourceMappingURL=style.js.map